import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
//import { IconButton, Tooltip } from '@mui/material';
//import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";
import { InfoToolTip } from "../../commonComponents/generalComponents"

export default function ProductHomeSpinningWheel() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [])

    return <div>
            <CcTitle>
                Spinning Wheel
            </CcTitle>

            <div className=" text-ccColorDarkTeal">Create interactive, branded spin-to-win experiences that boost engagement by revealing personalised offers tailored to each recipient. Using CRM data, you can customise rewards based on customer preferences, ensuring every spin delivers a relevant and compelling incentive.</div>

            <Link to={`/workflow/16`} style={linkStyle}>
                <CcCreateNewSnippet className="mt-4" >Create Spinning Wheel</CcCreateNewSnippet>
            </Link>

            <CcSubSectionTitle className=" mt-6">Latest Spinning Wheel Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={16}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}